export default "__VITE_ASSET__DPQxOH0N__"